module.exports = __webpack_public_path__ + "static/media/De_Koperhorst.b0c5abba.svg";